import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import getBreadcrumb from "domain/navigation/breadcrumbs";
import { INavigationItem } from "../../domain/navigation/navigation-item";
import { PAGE_NOT_FOUND } from "../../utils/constants";
import { ILooseObject } from "../../utils/rest";

export const PageTitle: React.FunctionComponent<ILooseObject> = ({
  displayAddButton: _displayAddButton = false,
  displayCardCount: _displayCardCount = true,
  id = "",
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [pageDetails, setPageDetails] = useState<INavigationItem | undefined>();
  const [loading, setIsLoading] = useState<boolean>(true);

  // OnMount
  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      const navigationItems = undefined;
      const breadCrumb = getBreadcrumb(id !== "" ? id : location.pathname, navigationItems);
      const pageDetails = breadCrumb ? breadCrumb[breadCrumb.length - 1] : { label: "Page not Found", to: "/", visible: false };
      setPageDetails(pageDetails);
      setIsLoading(false);
    };

    init();
  }, [id, location.pathname]);

  return (
    <Helmet>
      <title>
        {t("app_name")}
        {!loading && pageDetails?.label && pageDetails.label !== PAGE_NOT_FOUND ? ` - ${t(pageDetails.label)}` : ""}
      </title>
    </Helmet>
  );
};
